import getApiBaseUrl from '@/utils/getBaseUrl';
import { useQuery } from '@tanstack/react-query';
import { Profile } from './useGetProfile';

export default function useGetAgent(agent?: string) {
  return useQuery<Profile>({
    queryKey: ['AGENT'],
    queryFn: async () => {
      const response = await fetch(
        `${getApiBaseUrl()}/api/v1/users/agent/${agent}`,
        {
          headers: {
            'Content-Type': 'application/json',
          },
        },
      );

      if (!response.ok) {
        throw new Error(`Failed to fetch profile: ${response.statusText}`);
      }

      return (await response.json()).data;
    },
    enabled: !!agent,
  });
}
